import React, { useEffect, useState } from 'react';
import globalStyles from '../globals.module.css'; // Import CSS for notifications
import eventBus from '../../service/eventBus';
import { EVENT_NOTIFICATION_PUSH } from '../../utils/constants';

const Notification = () => {
    const componentId = 'Notification';
    const [notification, setNotification] = useState(null); // State to hold the current notification
    const [notificationType, setNotificationType] = useState('');
    // const [notification, setNotification] = useState(null); // State to hold the current notification
    // Effect to handle notification display
    useEffect(() => {
        eventBus.on(componentId, EVENT_NOTIFICATION_PUSH, (notification) => {
            setNotification(notification);
            setNotificationType(notification.type);
            setTimeout(() => {
                setNotification(null);
            }, 1000);
        });

        return () => {
            eventBus.off(componentId, EVENT_NOTIFICATION_PUSH);
        };
    }, [notification]);

    // if (!notification) return null; // Return null if no notification

    return (
        <div className={globalStyles.notificationContainer}>
            {notification && <div className={`${notification.type === 'notificationSuccess' ? globalStyles.notificationSuccess : globalStyles.notificationError}`}>
                {notification.message}
            </div>}
        </div>
    );
};

export default Notification; 